import React, { useEffect, useState } from 'react'

import { Button, InputNumber, Select } from 'antd'

import { getApiTargetInfo } from 'core'
import {
  getUtilityNameMap,
  getUnitNameMap,
  getPermitActions,
  getEnvConfig,
} from 'core/selectors'

import moment from 'moment'
import R from 'ramda'

import { Label } from 'core/screen-util'
import { SppAcaParametersHeaders } from './ACAHeaders'
import { deleteparameter, getparameter, postparameter } from './acaapi'
import { connect } from 'react-redux'
import CommonScreen from 'admin/component/CommonScreen'
import { hasAccesPermits } from 'core/utils'
import * as ScreenPermissions from 'core/EventActions'

const ACACParameter = ({ permitActions }) => {
  const [insertEvent, setInsertEvent] = useState(false)

  const insertComp = ({ insertData, setInsertData, onAdd, onCancel }) => {
    return (
      <div
        style={{
          display: 'grid',
          gridTemplateColumns:
            '100px 150px 200px 150px  200px 150px 150px 100px 150px',
          gap: 5,
        }}
      >
        <Label>Year :</Label>
        {/* <InputNumber
          value={insertData.year}
          onChange={val => setInsertData({ ...insertData, year: val })}
        /> */}
        <Select
          value={insertData.year}
          style={{ width: 120 }}
          onChange={val => {
            setInsertData({ ...insertData, year: val })
          }}
        >
          {R.range(-15, 10).map(idx => {
            const y = moment().year() - idx
            return (
              <Select.Option key={y} value={y}>
                {y}
              </Select.Option>
            )
          })}
        </Select>
        <Label>Incremental Outage Impact :</Label>
        <InputNumber
          value={insertData.incrementalOutageImpact}
          onChange={val =>
            setInsertData({ ...insertData, incrementalOutageImpact: val })
          }
        />
        <Label>Total System EFOF Impact :</Label>
        <InputNumber
          value={insertData.totalSystemEfofImpact}
          onChange={val =>
            setInsertData({ ...insertData, totalSystemEfofImpact: val })
          }
        />

        <div style={{ gridColumnEnd: 'span 3' }}>
          <Button type="primary" onClick={() => onAdd(true)}>
            Add
          </Button>

          <Button
            type="primary"
            onClick={() => onAdd(false)}
            style={{ marginLeft: '20px' }}
          >
            Add & Hide
          </Button>
          <Button
            type="danger"
            onClick={onCancel}
            style={{ marginLeft: '20px' }}
          >
            Cancel
          </Button>
        </div>
      </div>
    )
  }
  const [withoutModify, setWithoutModify] = useState(true)
  useEffect(() => {
    const isAdmin = hasAccesPermits({
      actionPermits: permitActions,
      eventActions: [ScreenPermissions.AEP_ACA_SPP_DATA_WRITE],
      matchAny: true,
    })
    setWithoutModify(!isAdmin)
  }, [permitActions])

  return (
    <CommonScreen
      title="SPP ACAP Parameters"
      header={SppAcaParametersHeaders}
      initialSortOptions={SppAcaParametersHeaders}
      saveTask={postparameter}
      retrieveTask={getparameter}
      deleteTask={deleteparameter}
      altBy={d => d.year}
      autoRetrieve
      insertComp={insertEvent && insertComp}
      insertCompHeight={90}
      onInsertEvent={b => setInsertEvent(b)}
      headerRowHeight={30}
      defaultInsertData={{ year: moment().year() }}
      isAdminScreen={false}
      withoutModify={withoutModify}
      allowInsert={!withoutModify}
      // widthOffset={550}
      // heightOffset={100}
    />
  )
}

const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
  utilityNameMap: getUtilityNameMap(state),
  unitNameMap: getUnitNameMap(state),
  permitActions: getPermitActions(state),
  envConfig: getEnvConfig(state),
})

export default connect(mapStateToProps)(ACACParameter)
